"use client"

import { getMyRangeSummary, type RangeSummary } from "@/lib/data/my-range"
import { ensureGtag } from "@/lib/util/analytics"
import LocalizedClientLink from "@/modules/common/components/localized-client-link"
import { useEffect, useState } from "react"

/**
 * Homepage strip for signed-in trade accounts: "Picked for <your business> - N products" -> /account/range.
 * Also for visitors who came from an outreach email (elv_ref/elv_range cookie) -> their /trade/<range> page.
 * Fetched after load via a server action so the homepage itself stays static (Lighthouse). Renders nothing
 * for visitors, holdout accounts and accounts without a range.
 */
export default function HomeRangeBanner() {
  const [s, setS] = useState<RangeSummary | null>(null)
  useEffect(() => {
    getMyRangeSummary()
      .then((r) => {
        setS(r)
        const g = r && ensureGtag()
        if (g && r && !r.anon) g("set", "user_properties", { elevate_range: r.range_key || "none", elevate_holdout: r.holdout ? "yes" : "no" })
      })
      .catch(() => {})
  }, [])
  if (!s?.label || s.holdout || !s.count) return null
  return (
    <div className="bg-elevate-black text-white" data-testid="home-range-banner">
      <LocalizedClientLink href={s.href} className="content-container flex items-center justify-between gap-3 py-3 text-sm">
        <span>
          <span className="text-elevate-gold uppercase tracking-[0.12em] text-xs mr-2">{s.anon ? "For your business" : "Your range"}</span>
          Picked for {s.label.charAt(0).toLowerCase() + s.label.slice(1)}: {s.count} products
        </span>
        <span className="underline underline-offset-4 whitespace-nowrap">View →</span>
      </LocalizedClientLink>
    </div>
  )
}
